module.exports = __webpack_public_path__ + "static/media/label.b0fd523c.svg";